module.exports = __webpack_public_path__ + "img/downloaded-user-active.84b4813b.svg";